import { Dispatch } from "react"
import { GETAPI, POSTAPI } from "../../api/Api"
import {CART_ADD_RESET , CART_ADD_REQUEST ,CART_ADD_SUCCESS ,CART_ADD_FAIL ,
        GET_CART_LIST_SUCCESS , GET_CART_LIST_FAIL ,
        CART_DELETE_RESET , CART_DELETE_REQUEST, CART_DELETE_SUCCESS , CART_DELETE_FAIL,
        STRIPE_PAYMENT_RESET , STRIPE_PAYMENT_REQUEST, STRIPE_PAYMENT_SUCCESS , STRIPE_PAYMENT_FAIL,
        PAYPAL_PAYMENT_RESET , PAYPAL_PAYMENT_REQUEST, PAYPAL_PAYMENT_SUCCESS , PAYPAL_PAYMENT_FAIL,
        PAYU_PAYMENT_RESET , PAYU_PAYMENT_REQUEST, PAYU_PAYMENT_SUCCESS , PAYU_PAYMENT_FAIL,
     } from "../../constants/PaymentConstants";
import { renderFormData } from "../../utils/Helper";

export const GetCartListAction = (payload: any) => async (dispatch: Dispatch<any>) => {
      try {
        let data = await POSTAPI('/cart/get', payload,false);
        if (data && data?.status === true) {
             dispatch({
                type: GET_CART_LIST_SUCCESS,
                data: data?.data
            })
        }
        else {
            dispatch({
                type: GET_CART_LIST_FAIL,
                data: data?.data
            })
        }
    }
    catch (error: any) {
        dispatch({
            type: "GET_CART_LIST_FAIL",
            payload: error.message
        });
    }
};

export const CartAddAction = (payload: any) => async (dispatch: Dispatch<any>) => {

    if (payload === 'RESET') {
        dispatch({ type: CART_ADD_RESET });
    }
    else {
        try {        
            dispatch({
                type: CART_ADD_REQUEST
            });
            let payloadData = payload;
            let data = await POSTAPI('cart/add', payloadData);
            if (data && data?.status === true) {
                dispatch({
                    type: CART_ADD_SUCCESS,
                    payload: data
                })
            }
            else {
                dispatch({
                    type: CART_ADD_FAIL,
                    payload: data
                })
            }
        }
        catch (error: any) {
            dispatch({
                type: CART_ADD_FAIL,
                payload: error.message
            });
        }
    }
};

export const CartDeleteAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: CART_DELETE_RESET });
    }
    else {
        try {
            dispatch({
                type: CART_DELETE_REQUEST
            });
            let data = await POSTAPI('cart/delete', payload);
            if (data && data?.status === true) {
                dispatch({
                    type: CART_DELETE_SUCCESS,
                    payload: data
                });
            }
            else {
                dispatch({
                    type: CART_DELETE_FAIL,
                    payload: data
                });
            }
        }
        catch (error: any) {
            dispatch({
                type: CART_DELETE_FAIL,
                payload: error.message
            });
        }
    }
};

export const StripePaymentAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: STRIPE_PAYMENT_RESET });
    }
    else {
        try {        
            dispatch({
                type: STRIPE_PAYMENT_REQUEST
            });
            let payloadData = payload;

            let data = await POSTAPI('stripe/payment', payloadData);
            
            if (data && data?.status === true) {
                dispatch({
                    type: STRIPE_PAYMENT_SUCCESS,
                    payload: data
                })
            }
            else {
                dispatch({
                    type: STRIPE_PAYMENT_FAIL,
                    payload: data
                })
            }
        }
        catch (error: any) {
            dispatch({
                type: STRIPE_PAYMENT_FAIL,
                payload: error.message
            });
        }
    }
};

export const PaypalPaymentAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: PAYPAL_PAYMENT_RESET });
    }
    else {
        try {        
            dispatch({
                type: PAYPAL_PAYMENT_REQUEST
            });
            let payloadData = payload;

            let data = await POSTAPI('paypal/payment', payloadData);
            
            if (data && data?.status === true) {
                dispatch({
                    type: PAYPAL_PAYMENT_SUCCESS,
                    payload: data
                })
            }
            else {
                dispatch({
                    type: PAYPAL_PAYMENT_FAIL,
                    payload: data
                })
            }
        }
        catch (error: any) {
            dispatch({
                type: PAYPAL_PAYMENT_FAIL,
                payload: error.message
            });
        }
    }
};

export const PayuPaymentAction = (payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: PAYU_PAYMENT_RESET });
    }
    else {
        try {        
            dispatch({
                type: PAYU_PAYMENT_REQUEST
            });
            let payloadData = payload;

            let data = await POSTAPI('payu/payment', payloadData);
            
            if (data && data?.status === true) {
                dispatch({
                    type: PAYU_PAYMENT_SUCCESS,
                    payload: data
                })
            }
            else {
                dispatch({
                    type: PAYU_PAYMENT_FAIL,
                    payload: data
                })
            }
        }
        catch (error: any) {
            dispatch({
                type: PAYU_PAYMENT_FAIL,
                payload: error.message
            });
        }
    }
};

